import { z } from 'zod';
import { c } from '../contract';
import { searchAutocompleteResponse, searchResultsResponse } from '../schemas';

const errorResponse = z.object({ error: z.string() });

export const searchRouter = c.router(
  {
    autocomplete: {
      method: 'GET',
      path: '/autocomplete',
      query: z.object({
        query: z.string().min(2),
        language: z.string().optional(),
      }),
      responses: {
        200: searchAutocompleteResponse,
        403: errorResponse,
        500: errorResponse,
      },
    },
    results: {
      method: 'GET',
      path: '/results',
      query: z.object({
        query: z.string().min(1),
        language: z.string().optional(),
        page_number: z.number().optional(),
        page_size: z.number().optional(),
      }),
      responses: {
        200: searchResultsResponse,
        403: errorResponse,
        500: errorResponse,
      },
    },
  },
  { pathPrefix: '/search' },
);
